import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=41ed8dad&"
import script from "./portal.vue?vue&type=script&lang=js&"
export * from "./portal.vue?vue&type=script&lang=js&"
import style0 from "./portal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
